import 'simplebar/dist/simplebar.min.css';
import './assets/css/fortress.css';

import { useContext } from 'react';
import { Container } from 'react-bootstrap';
import { Navigate, Route, Routes } from 'react-router-dom';

import Loading from './components/helper/Loading';
import AllowedRoute from './components/routes/AllowedRoute';
import AuthBrandRoute from './components/routes/AuthBrandRoute';
import AuthRoute from './components/routes/AuthRoute';
import AuthUserInternalManagerRoute from './components/routes/AuthUserInternalManagerRoute';
import LoggedInRoute from './components/routes/LoggedInRoute';
import NoAuthRoute from './components/routes/NoAuthRoute';
import { AuthContext } from './contexts/AuthContext';
import { ErrorBoundary } from './contexts/ErrorContext';
import { ROUTES } from './core/routes';
// Dashboard Brand
import BrandTimeline from './pages/BrandSummary/BrandTimeline';
// Dashboard Customer
import CustomerGeography from './pages/customer/customerGeography';
import Forgot from './pages/Login/Forgot';
// Login
import Login from './pages/Login/Login';
import Register from './pages/Login/Register';
import Reset from './pages/Login/Reset';
import Verify from './pages/Login/Verify';
import VerifyAlreadySuccess from './pages/Login/VerifyAlreadySuccess';
import VerifySuccess from './pages/Login/VerifySuccess';
import MaintenanceMode from './pages/MaintenanceMode';
import NotFound from './pages/NotFound';
//Market Intelligence
//Paid Media
import PaidMedia from './pages/PaidMedia/Dashboard';
import BundlePerformance from './pages/performance/BundlePerformance';
import CategoryPerformance from './pages/performance/CategoryPerformance';
// Dashboard Performance
import ProductPerformance from './pages/performance/productPerformance';
import SNSPerformance from './pages/performance/SNSPerformance';
import { PerformanceCenter } from './pages/performanceCenter/PerformanceCenter';
import { PerformanceCenterBeforeRender } from './pages/performanceCenter/PerformanceCenterBeforeRender';
import AutoAcosPage from './pages/PPC/AutoAcos';
import CustomerJourney from './pages/PPC/CustomerJourney';
import KeywordAnalysis from './pages/PPC/KeywordAnalysis';
// Dashboard PPC
import Overview from './pages/PPC/Overview';
import ProductsxCampaign from './pages/PPC/ProductsxCampaign';
import Timeline from './pages/PPC/Timeline';
//Promotions
import PromotionalReporting from './pages/Promotions/PromotionalReporting';
// Public
import Help from './pages/Public/Help';
// Dashboard Quantitative
import QuantitativeReport from './pages/Quantitative/QuantitativeReport';
// Dashboard Reseller
import BuyboxOverview from './pages/Resellers/BuyboxOverview';
import TrafficConversion from './pages/TrafficConversion/TrafficConversion';
import Unauthorized from './pages/Unauthorized';
import ClientWizard from './pages/User/ClientWizard';
import InviteClient from './pages/User/InviteClient';
// Logged In

const SiteRoutes = () => {
  //All routes will wait for AuthContext to finish initializing/loading before rendering.
  const { isLoading, loading: isAuthLoading, isLoggedIn } = useContext(AuthContext);

  const renderNoAuthRoutes = () => {
    return (
      <div className="main-display flex-grow-1">
        <Routes>
          <Route element={<NoAuthRoute />}>
            <Route path="/" element={<Login />} />
            <Route path={ROUTES.LOGIN} element={<Login />} />
            <Route path={ROUTES.REGISTER} element={<Register />} />
            <Route path={ROUTES.FORGOT} element={<Forgot />} />
            <Route path={ROUTES.VERIFY_SUCCESS} element={<VerifySuccess />} />
            <Route path={ROUTES.HELP} element={<Help />} />
            <Route path={ROUTES.UNAUTHORIZED} element={<Unauthorized />} />
            <Route path={ROUTES.MAINTENANCE} element={<MaintenanceMode />} />
          </Route>
          <Route element={<LoggedInRoute />}>
            <Route path="*" element={<Unauthorized />} />
          </Route>
        </Routes>
      </div>
    );
  };

  const renderRoutes = () => {
    return (
      <ErrorBoundary>
        <Routes>
          <Route element={<NoAuthRoute />}>
            <Route path={ROUTES.LOGIN} element={<Login />} />
            <Route path={ROUTES.REGISTER} element={<Register />} />
            <Route path={ROUTES.VERIFY_SUCCESS} element={<VerifySuccess />} />
          </Route>
          <Route element={<AuthRoute />}>
            <Route path={ROUTES.FORGOT} element={<Forgot />} />
            <Route path={ROUTES.RESET} element={<Reset />} />
            <Route path={ROUTES.HELP} element={<Help />} />
            <Route path={ROUTES.VERIFY_ALREADY_SUCCESS} element={<VerifyAlreadySuccess />} />
            <Route path={ROUTES.BRAND} element={<ClientWizard />} />
            <Route path={ROUTES.NOT_FOUND} element={<NotFound />} />
          </Route>
          <Route element={<LoggedInRoute />}>
            <Route path={ROUTES.VERIFY} element={<Verify />} />
          </Route>
          <Route element={<AuthBrandRoute />}>
            <Route path="/" element={<Navigate to={ROUTES.PERFORMANCE_CENTER} replace />} />
            <Route
              path={ROUTES.BRAND_SUMMARY}
              element={<Navigate to={ROUTES.PERFORMANCE_CENTER} replace />}
            />
            <Route
              path={ROUTES.PERFORMANCE_CENTER}
              element={
                <PerformanceCenterBeforeRender>
                  <PerformanceCenter />
                </PerformanceCenterBeforeRender>
              }
            />
            <Route path={ROUTES.BRAND_TIMELINE} element={<BrandTimeline />} />
            <Route path={ROUTES.BRAND_TRAFFIC} element={<TrafficConversion />} />

            <Route path={ROUTES.PERFORMANCE_PRODUCTS} element={<ProductPerformance />} />
            <Route path={ROUTES.PERFORMANCE_CATEGORY} element={<CategoryPerformance />} />
            <Route path={ROUTES.PERFORMANCE_BUNDLES} element={<BundlePerformance />} />

            <Route path={ROUTES.PROMOTIONS_REPORTS} element={<PromotionalReporting />} />
            <Route path={ROUTES.PERFORMANCE_SNS} element={<SNSPerformance />} />

            <Route path={ROUTES.PPC_OVERVIEW} element={<Overview />} />
            <Route path={ROUTES.PPC_TIMELINE} element={<Timeline />} />
            <Route path={ROUTES.PPC_PRODUCTS} element={<ProductsxCampaign />} />
            <Route path={ROUTES.PPC_KEYWORDS_ANALYSIS} element={<KeywordAnalysis />} />
            <Route path={ROUTES.PPC_JOURNEY} element={<CustomerJourney />} />
            <Route path={ROUTES.PPC_RESELLERS_BUYBOX} element={<BuyboxOverview />} />
            <Route path={ROUTES.PPC_AUTOACOS} element={<AutoAcosPage />} />
            <Route path={ROUTES.PPC_PAID_MEDIA} element={<PaidMedia />} />
            <Route path={ROUTES.BRAND_QUANTITATIVE} element={<QuantitativeReport />} />
          </Route>

          <Route element={<AuthUserInternalManagerRoute />}>
            <Route element={<AuthBrandRoute />}>
              <Route path={ROUTES.INVITE_CLIENT} element={<InviteClient />} />
            </Route>
          </Route>

          <Route element={<AllowedRoute />}>
            <Route element={<AuthBrandRoute />}>
              <Route path={ROUTES.CUSTOMER_GEOGRAPHY} element={<CustomerGeography />} />
            </Route>
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </ErrorBoundary>
    );
  };

  return (
    <Container
      fluid
      className="bg-white d-flex flex-row justify-content-between m-0 p-0"
      style={{ height: '100vh', overflow: 'hidden' }}
    >
      {(isLoading || isAuthLoading) === true ? (
        <Loading></Loading>
      ) : isLoggedIn === false ? (
        renderNoAuthRoutes()
      ) : (
        renderRoutes()
      )}
    </Container>
  );
};

export default SiteRoutes;
